// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","content":"Header_content__8sQm-","title":"Header_title__l+wMf","subtitle":"Header_subtitle__KVA1a"};